import { MetricUId } from "../../Metrics/constants"
import getChartConfigTemplate from "../Templates/PieChart/utils"
import { mergeProps } from "../../../generic/Utils/mergeProps";

const metricColorMap = {
  [MetricUId.ONGOING_GROUPS_COUNT]: "#FC8543",
  [MetricUId.CLOSED_GROUPS_COUNT]: "#0969DA",
  [MetricUId.DRAFTED_GROUPS_COUNT]: "#F44E4E",
  [MetricUId.PROPOSED_GROUPS_COUNT]: "#194D74",
  [MetricUId.PENDING_GROUPS_COUNT]: "#8E4EC6",
  [MetricUId.WITHDRAWN_GROUPS_COUNT]: "#E54D2E",
  [MetricUId.REJECTED_GROUPS_COUNT]: "#D4D4D4"
}

export const chartOnlyMetrics = [MetricUId.ONGOING_GROUPS_COUNT, MetricUId.CLOSED_GROUPS_COUNT, MetricUId.DRAFTED_GROUPS_COUNT, MetricUId.PROPOSED_GROUPS_COUNT, MetricUId.PENDING_GROUPS_COUNT, MetricUId.WITHDRAWN_GROUPS_COUNT, MetricUId.REJECTED_GROUPS_COUNT, MetricUId.TOTAL_GROUPS_COUNT]

const getChartConfig = function(props = {}) {
  const mergedProps = mergeProps(props, {
    seriesMetricsUids: [MetricUId.ONGOING_GROUPS_COUNT, MetricUId.CLOSED_GROUPS_COUNT, MetricUId.DRAFTED_GROUPS_COUNT, MetricUId.PROPOSED_GROUPS_COUNT, MetricUId.PENDING_GROUPS_COUNT, MetricUId.WITHDRAWN_GROUPS_COUNT, MetricUId.REJECTED_GROUPS_COUNT],
    subTitleMetricUid: MetricUId.TOTAL_GROUPS_COUNT,
    exportFileName: props.name,
    metricColorMap: metricColorMap
  });

  return getChartConfigTemplate(mergedProps);
};

export default getChartConfig;
